/* tslint:disable */
/* eslint-disable */
/**
 * B2B Air Shopping
 * Endpoints needed to complete air shopping  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.prediction.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.prediction.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `application_error` * `bad_request` * `check_in_minimum_age_not_met` * `duplicate_booking` * `duplicated_national_id` * `duplicated_passport` * `expired_national_id` * `expired_passport` * `expiring_national_id` * `expiring_passport` * `extra_bags_error` * `illegal_lap_infant_ktn` * `illegal_lap_infant_redress` * `inactivity` * `ineligible` * `internal_error` * `invalid_customer` * `invalid_passenger_name` * `invalid_passengers` * `invalid_passport_number` * `invalid_passport_or_national_id_number` * `lap_infant_too_old` * `lap_infants_unsupported` * `malformed_known_traveler_number` * `malformed_redress_number` * `missing_airline_locator` * `missing_national_id` * `missing_nationality` * `missing_passport_number` * `missing_passport_or_national_id` * `missing_passport` * `no_adult_passenger` * `no_availability` * `no_contact_information` * `no_ticketless_response` * `passenger_name_too_short` * `provider_error` * `request_deserialization_error` * `response_serialization_error` * `restricted_city` * `restricted_country` * `seated_infants_unsupported` * `session_closed` * `shop_async_error` * `ticketing_not_started` * `ticketing_unconfirmed` * `ticketing_unknown` * `too_many_lap_infants` * `too_many_passengers` * `transient_service_error` * `unknown_sabre_app_error` * `unknown` * `unsupported_name_characters` * `upgrade_required` * `user_not_found`
 *
 * The version of the OpenAPI document: v9p114
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface Air {
    'Funnel': FunnelEnum;
}


export interface Aircraft {
    'info': AmenityInfo;
}
export interface Airline {
    'displayName': string;
    'customHashTag'?: string;
    'fullName': string;
    'isLcc': boolean;
    'webLinks': WebLinks;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Airline
     */
    'code': string;
    'cabinClassMappings': { [key: string]: HopperCabinClass; };
    'phone'?: string;
}
/**
 * `cityName` - The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
 * `servedCity` - IATA has a concept of "served metropolitan area";
   e.g. Newark Intl Airport (EWR) is geographically in Newark but "serves" NYC
   This is a good presumed destination (for example for hotels or whatever)
   It is not however an acceptable display name for the airport (So we should not display EWR as "New York (EWR)")
 * `military` - military airports often place restrictions on international travelers
 * @export
 * @interface Airport
 */
export interface Airport {
    'coordinates': Coordinates;
    'servedCityName': string;
    'name': string;
    /**
     * The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
     * @type {string}
     * @memberof Airport
     */
    'cityName': string;
    /**
     * 3 character IATA city code
     * @type {string}
     * @memberof Airport
     */
    'servedCity': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Airport
     */
    'code': string;
    'geography': GeopoliticalInfo;
    /**
     * military airports often place restrictions on international travelers
     * @type {boolean}
     * @memberof Airport
     */
    'military': boolean;
}
/**
 * When regionType is airport, code represents an IATA airport code and when regionType is city, code is an IATA city code
 * @export
 * @interface AirportRegion
 */
export interface AirportRegion {
    'regionType': RegionType;
    'code': string;
}


export interface AmadeusBrand {
    'brandId': string;
    'brandName'?: string;
}
export interface Amenities {
    'seat': Seat;
    'aircraft': Aircraft;
    'entertainment': Entertainment;
    'beverage': Beverage;
    'wifi': Wifi;
    'layout': Layout;
    'power': Power;
    'freshFood': FreshFood;
}
export interface AmenitiesAndUtasPerSlice {
    'amenitiesAndUtas': Array<AmenitiesAndUtasV2>;
}
export interface AmenitiesAndUtasV2 {
    'amenities'?: Amenities;
    'utas': UtasV2;
    'upas': Array<Upa>;
}
export interface AmenitiesFare {
    'brandName': string;
    'brandCodes': Array<string>;
}
export const AmenityExists = {
    na: 'na',
    no: 'no',
    yes: 'yes'
} as const;

export type AmenityExists = typeof AmenityExists[keyof typeof AmenityExists];


export interface AmenityInfo {
    'displayText'?: string;
    'quality': AmenityQuality;
    'updatedAt'?: string;
}


export const AmenityQuality = {
    better: 'better',
    na: 'na',
    standard: 'standard'
} as const;

export type AmenityQuality = typeof AmenityQuality[keyof typeof AmenityQuality];


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export interface AndFilter {
    'filters': Array<TripFilter>;
    'TripFilter': TripFilterEnum;
}


export const AssessmentV2 = {
    Benefit: 'Benefit',
    Fee: 'Fee',
    Neutral: 'Neutral',
    Restriction: 'Restriction'
} as const;

export type AssessmentV2 = typeof AssessmentV2[keyof typeof AssessmentV2];


export interface BagLimits {
    'weightKg'?: string;
    'sizeLcm'?: string;
}
export interface BaggageCharge {
    'firstPiece': number;
    'amount': number;
    'maximumMass'?: Mass;
    'lastPiece': number;
    'currency': string;
    'descriptions': Array<string>;
}
export interface Beverage {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


export const BrandType = {
    BasicEconomy: 'BasicEconomy',
    Business: 'Business',
    Economy: 'Economy',
    First: 'First',
    PremiumEconomy: 'PremiumEconomy',
    Unknown: 'Unknown'
} as const;

export type BrandType = typeof BrandType[keyof typeof BrandType];


export interface CalendarBuckets {
    'route': Route;
    'tripType': TripType;
    'filter': TripFilter;
}


export interface CalendarBucketsResponse {
    'departureDateReport': DepartureDateReport;
}
export interface CategorizedResponse {
    'category': Category;
    'label': string;
    'results': Array<Suggestion>;
}


export const Category = {
    airports: 'airports',
    cities: 'cities',
    recentSearches: 'recentSearches'
} as const;

export type Category = typeof Category[keyof typeof Category];


export const Control = {
    destination: 'destination',
    origin: 'origin'
} as const;

export type Control = typeof Control[keyof typeof Control];


export interface Coordinate {
    'lat': number;
    'lon': number;
    'searchParameters'?: SearchParameters;
    'LocationQuery': LocationQueryEnum;
}


export interface Coordinates {
    'lat': number;
    'lon': number;
}
export interface CorporateTravel {
    'policyCompliance': PolicyCompliance;
}
export interface Cta {
    'text': string;
    'url': string;
}
export const Dealness = {
    fair: 'fair',
    good: 'good',
    great: 'great',
    wait: 'wait'
} as const;

export type Dealness = typeof Dealness[keyof typeof Dealness];


export interface DepartureDateReport {
    'currency': string;
    'isReliable': boolean;
    'departureDateBuckets': Array<DeparturePriceBucket>;
    'filtersSummary': FiltersSummary;
}
export interface DeparturePriceBucket {
    'legend': string;
    'dates': Array<string>;
}
/**
 * A displayable monetary amount
 * @export
 * @interface DisplayAmount
 */
export interface DisplayAmount {
    'amount': Amount;
    'display': string;
}
export interface Empty {
    'LocationQuery': LocationQueryEnum;
}


export interface Entertainment {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


export interface ErrorCode {
    'code': string;
    'details'?: string;
    'trackingCode'?: string;
}
/**
 * one instance of a [[Trip.ID]]/[[Fare.ID]] corresponding to this outbound.
 * @export
 * @interface Example
 */
export interface Example {
    'trip': string;
    'fare': string;
}
export interface Failure {
    'errors': Array<ErrorCode>;
    'Response': ResponseEnum;
}


/**
 * `return` - pointer to second leg of fare (can be shared with other Fare)
 * `amount` - price of the fare; will be empty for Southwest
 * `id` - unique ID
 * `outbound` - pointer to first leg of fare (can be shared with other Fare)
 * @export
 * @interface Fare
 */
export interface Fare {
    /**
     * pointer to second leg of fare (can be shared with other Fare)
     * @type {string}
     * @memberof Fare
     */
    'return'?: string;
    'tripId': string;
    'amount'?: Prices;
    /**
     * unique ID
     * @type {string}
     * @memberof Fare
     */
    'id': string;
    /**
     * pointer to first leg of fare (can be shared with other Fare)
     * @type {string}
     * @memberof Fare
     */
    'outbound': string;
    'multiTicketType': MultiTicketType;
    'corporateTravel'?: CorporateTravel;
    'fareScore': FlightsFareScore;
}


export interface FareBrand {
    'gdxFareBrand'?: GdxBrand;
    'amadeusFareBrand'?: AmadeusBrand;
    'navitaireNdcBrand'?: NavitaireNdcBrand;
    'travelportFareBrand'?: TravelportBrand;
    'sabreFareBrand'?: SabreBrand;
    'travelFusionFareBrand'?: TravelFusionBrand;
}
export interface FareDetailsV2 {
    'penaltiesInfo'?: PenaltiesInfo;
    'refundable'?: boolean;
    'paxPricings'?: Array<PassengerPricing>;
    'timestamp': number;
    'excludeINS'?: boolean;
    'restrictions'?: Array<AmenitiesAndUtasPerSlice>;
    'took'?: number;
    'id': string;
    'conversationId': string;
    'multiTicketType'?: MultiTicketType;
    'corporateTravel'?: CorporateTravel;
    'slices': Array<FareSliceDetailsV2>;
    'multiTicket': boolean;
    'fareScore'?: FareScore;
}


export interface FarePricing {
    'baseAmount': Prices;
    'additionalMargin'?: Prices;
    'lastTicketDate'?: string;
    'totalWithDiscount'?: Prices;
    'total': Prices;
    'taxAmount': Prices;
}
export interface FareScore {
    'isFastest': boolean;
    'isBestQuality': boolean;
    'isCheapest': boolean;
    'comfort': number;
    'isBest': boolean;
    'value': number;
}
export interface FareShelf {
    'outgoing': SegmentShelf;
    'returning'?: SegmentShelf;
}
/**
 * `amount` - the lowest amount this fare can be sold at. For WN flights, this field will be empty; the front end will be listing flights with empty amount fields at the bottom when filtered by price.
 * `next` - a sorted list of [[Slice.Departure]] that can be used to complete this fare. This is effectively a trie, when followed, will terminate with a leaf node containing the [[Trip.ID]] representing the Slices chosen.
 * `example` - one instance of a [[Trip.ID]]/[[Fare.ID]] corresponding to this departure. The nomenclature here is misleading; this is not just an 'example' but is actually used to describe a current [[Trip]]/[[Fare]] representing the Slices chosen. If the given instance is a leaf node, then the example is the singular [[Trip]]/[[Fare]] representing the Slices chosen.
 * @export
 * @interface FareSliceDeparture
 */
export interface FareSliceDeparture {
    'fareSlice': string;
    'amount'?: Prices;
    /**
     * a sorted list of [[Slice.Departure]] that can be used to complete this fare. This is effectively a trie, when followed, will terminate with a leaf node containing the [[Trip.ID]] representing the Slices chosen.
     * @type {Array<SliceDeparture>}
     * @memberof FareSliceDeparture
     */
    'next'?: Array<SliceDeparture>;
    'example': MulticityExample;
}
export interface FareSliceDetailsV2 {
    'fareShelf'?: SegmentShelf;
    'outgoing': boolean;
    'amenitiesUtas'?: AmenitiesAndUtasV2;
    'fareDetails': ShopTripDetailsFareSlice;
    'sliceIndex': number;
}
export interface FareSliceFareShelf {
    'value': number;
}
/**
 * `highestScore` - The highest possible `FareScore` associated with a flight with this outbound `FareSlice`
 * `amount` - the lowest amount this fare can be sold at. For WN flights, this field will be empty;the front end will be listing flights with empty amount fields at the bottom when filtered by price.
 * `next` - if exists, the corresponding `return` [[Trip]] possible
 * `example` - one instance of a [[Trip.ID]]/[[Fare.ID]] corresponding to this outbound.
 * @export
 * @interface FareSliceOutbound
 */
export interface FareSliceOutbound {
    'fareSlice': string;
    'highestScore': FlightsFareScore;
    'amount'?: Prices;
    /**
     * if exists, the corresponding `return` [[Trip]] possible
     * @type {Array<string>}
     * @memberof FareSliceOutbound
     */
    'next'?: Array<string>;
    'example': Example;
}
export interface Fee {
    'currency': string;
    'price': number;
}
/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface FilterSummary {
    'filter': TripFilter;
    'summaryCopy': string;
    'summaryState': FilterSummaryState;
}


export const FilterSummaryState = {
    Better: 'Better',
    Normal: 'Normal',
    Warning: 'Warning',
    Worse: 'Worse'
} as const;

export type FilterSummaryState = typeof FilterSummaryState[keyof typeof FilterSummaryState];


export interface FiltersSummary {
    'summaries': Array<FilterSummary>;
}
export interface Flight {
    'code': AirportRegion;
    'Id': IdEnum;
}


/**
 * Models a recent flight search done by the user.
 * @export
 * @interface FlightSearch
 */
export interface FlightSearch {
    'tripProperties': TripProperties;
    'passengers': Passengers;
    'Id': IdEnum;
}


export interface Flights {
    'shopId': ShopId;
    'fareSlices': { [key: string]: FlightsFareSlice; };
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
    'outbound': Array<SliceOutbound>;
    'fares': { [key: string]: Fare; };
    'trips': { [key: string]: Trip; };
    'slices': { [key: string]: Slice; };
}
/**
 * The highest possible `FareScore` associated with a flight with this outbound `FareSlice`
 * @export
 * @interface FlightsFareScore
 */
export interface FlightsFareScore {
    'value': number;
}
export interface FlightsFareSegment {
    'availableSeats': number;
}
export interface FlightsFareSlice {
    'fareShelf': FareSliceFareShelf;
    'tags': Tags;
    'id': string;
    'slice': string;
    'segments': Array<FlightsFareSegment>;
    'fareBrandName': string;
}
export interface FreshFood {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


export const Funnel = {
    Air: 'Air',
    Ground: 'Ground',
    Lodging: 'Lodging'
} as const;

export type Funnel = typeof Funnel[keyof typeof Funnel];


export const FunnelEnum = {
    Air: 'Air',
    Ground: 'Ground',
    Lodging: 'Lodging'
} as const;

export type FunnelEnum = typeof FunnelEnum[keyof typeof FunnelEnum];


export interface GdxBrand {
    'brandId': string;
    'brandName'?: string;
}
export interface GeopoliticalInfo {
    /**
     * 2 character country code
     * @type {string}
     * @memberof GeopoliticalInfo
     */
    'countryCode': string;
    'regionCode'?: string;
    'currency': string;
    'timeZone': string;
}
export interface Ground {
    'Funnel': FunnelEnum;
}


export const HopperCabinClass = {
    Business: 'Business',
    Economy: 'Economy',
    First: 'First',
    PremiumEconomy: 'PremiumEconomy',
    Unknown: 'Unknown'
} as const;

export type HopperCabinClass = typeof HopperCabinClass[keyof typeof HopperCabinClass];


export interface Icon {
    'smallIconUrl': string;
    'largeIconUrl': string;
}
/**
 * @type Id
 * @export
 */
export type Id = { Id: 'Flight' } & Flight | { Id: 'FlightSearch' } & FlightSearch;

export const IdEnum = {
    Flight: 'Flight',
    FlightSearch: 'FlightSearch'
} as const;

export type IdEnum = typeof IdEnum[keyof typeof IdEnum];


export interface Interval {
    'dates': string;
    'copy': string;
}
export interface Intervals {
    'normal'?: Interval;
    'warning'?: Interval;
    'danger'?: Interval;
}
export interface InvalidSearchLocation {
    'invalidLocation': string;
    'ShopMulticitySummaryErrors': ShopMulticitySummaryErrorsEnum;
}


export interface IsEligible {
    'candidateId': string;
    'PriceDropProtection': PriceDropProtectionEnum;
    'trackingPropertiesV2': TrackingProperties;
    'maximumRefund': PriceDropMaximumRefund;
    'minimumRefund': PriceDropMinimumRefund;
    'monitoringDuration': PriceDropMonitoringDuration;
}


export interface Label {
    'l': string;
    'searchParameters'?: SearchParameters;
    'LocationQuery': LocationQueryEnum;
}


export interface Layout {
    'info': AmenityInfo;
}
/**
 * @type LocationQuery
 * @export
 */
export type LocationQuery = { LocationQuery: 'Coordinate' } & Coordinate | { LocationQuery: 'Empty' } & Empty | { LocationQuery: 'Label' } & Label | { LocationQuery: 'LodgingFeaturedMarkets' } & LodgingFeaturedMarkets;

export const LocationQueryEnum = {
    Coordinate: 'Coordinate',
    Empty: 'Empty',
    Label: 'Label',
    LodgingFeaturedMarkets: 'LodgingFeaturedMarkets'
} as const;

export type LocationQueryEnum = typeof LocationQueryEnum[keyof typeof LocationQueryEnum];


export interface LocationResponse {
    'categories': Array<CategorizedResponse>;
}
export interface Lodging {
    'Funnel': FunnelEnum;
}


export interface LodgingFeaturedMarkets {
    'LocationQuery': LocationQueryEnum;
}


export interface Mass {
    'value': number;
    'unit': string;
}
export interface MultiPolicyV2 {
    'afterDeparture'?: PolicyV2;
    'anytime'?: PolicyV2;
    'beforeDeparture'?: PolicyV2;
}
export const MultiTicketType = {
    hackerFare: 'hackerFare',
    single: 'single',
    virtualInterline: 'virtualInterline'
} as const;

export type MultiTicketType = typeof MultiTicketType[keyof typeof MultiTicketType];


/**
 * one instance of a [[Trip.ID]]/[[Fare.ID]] corresponding to this departure. The nomenclature here is misleading; this is not just an 'example' but is actually used to describe a current [[Trip]]/[[Fare]] representing the Slices chosen. If the given instance is a leaf node, then the example is the singular [[Trip]]/[[Fare]] representing the Slices chosen.
 * @export
 * @interface MulticityExample
 */
export interface MulticityExample {
    'trip': string;
    'fare': string;
}
/**
 * `fareSlices` - ordered sequence of fare slice corresponding to the legs of the fare
 * `amount` - price of the fare; will be empty for Southwest
 * `id` - unique ID
 * @export
 * @interface MulticityFare
 */
export interface MulticityFare {
    /**
     * ordered sequence of fare slice corresponding to the legs of the fare
     * @type {Array<string>}
     * @memberof MulticityFare
     */
    'fareSlices': Array<string>;
    'tripId': string;
    'amount'?: Prices;
    /**
     * unique ID
     * @type {string}
     * @memberof MulticityFare
     */
    'id': string;
    'fareScore': MulticityFlightsFareScore;
}
/**
 * the fare category from 0-4, where 0 maps to basic economy while 4 maps to luxury
 * @export
 * @interface MulticityFareSliceFareShelf
 */
export interface MulticityFareSliceFareShelf {
    'value': number;
}
/**
 * `departures` - Corresponds to the first set of Slices a user may choose. Following Slices are chosen from the `next` field of the chosen FareSlice.
 * `fareSlices` - Lookup table of FareSlices
 * `airports` - Lookup table of Airports
 * `airlines` - Lookup table of Airlines
 * `fares` - Lookup table of Fares
 * `trips` - Lookup table of Trips
 * `slices` - Lookup table of Slices
 * @export
 * @interface MulticityFlights
 */
export interface MulticityFlights {
    /**
     * Corresponds to the first set of Slices a user may choose. Following Slices are chosen from the `next` field of the chosen FareSlice.
     * @type {Array<SliceDeparture>}
     * @memberof MulticityFlights
     */
    'departures': Array<SliceDeparture>;
    'shopId': ShopId;
    /**
     * Lookup table of FareSlices
     * @type {{ [key: string]: MulticityFlightsFareSlice; }}
     * @memberof MulticityFlights
     */
    'fareSlices': { [key: string]: MulticityFlightsFareSlice; };
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
    /**
     * Lookup table of Fares
     * @type {{ [key: string]: MulticityFare; }}
     * @memberof MulticityFlights
     */
    'fares': { [key: string]: MulticityFare; };
    /**
     * Lookup table of Trips
     * @type {{ [key: string]: MulticityTrip; }}
     * @memberof MulticityFlights
     */
    'trips': { [key: string]: MulticityTrip; };
    /**
     * Lookup table of Slices
     * @type {{ [key: string]: MulticitySlice; }}
     * @memberof MulticityFlights
     */
    'slices': { [key: string]: MulticitySlice; };
}
export interface MulticityFlightsFareScore {
    'value': number;
}
export interface MulticityFlightsFareSegment {
    'availableSeats': number;
}
/**
 * `fareShelf` - the fare category from 0-4, where 0 maps to basic economy while 4 maps to luxury
 * `id` - unique ID
 * `slice` - corresponding slice for given [[FareSlice]]
 * @export
 * @interface MulticityFlightsFareSlice
 */
export interface MulticityFlightsFareSlice {
    'fareShelf': MulticityFareSliceFareShelf;
    'tags': MulticityTags;
    /**
     * unique ID
     * @type {string}
     * @memberof MulticityFlightsFareSlice
     */
    'id': string;
    /**
     * corresponding slice for given [[FareSlice]]
     * @type {string}
     * @memberof MulticityFlightsFareSlice
     */
    'slice': string;
    'segments': Array<MulticityFlightsFareSegment>;
    'fareBrandName': string;
}
/**
 * A description of a slice within a multicity trip containing origin, destination, and departure date

 * `departureDate` - The date of departure zoned to the timezone of the origin
 * @export
 * @interface MulticityRoute
 */
export interface MulticityRoute {
    'origin': AirportRegion;
    'destination': AirportRegion;
    /**
     * The date of departure zoned to the timezone of the origin
     * @type {string}
     * @memberof MulticityRoute
     */
    'departureDate': string;
}
export interface MulticitySegment {
    'plusDays': number;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof MulticitySegment
     */
    'marketingAirline': string;
    'stopoverDurationMinutes'?: number;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof MulticitySegment
     */
    'origin': string;
    'departure': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof MulticitySegment
     */
    'operatingAirline': string;
    'flightNumber': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof MulticitySegment
     */
    'destination': string;
    'arrival': string;
}
export interface MulticitySlice {
    'domestic': boolean;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof MulticitySlice
     */
    'marketingAirline': string;
    'id': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof MulticitySlice
     */
    'origin': string;
    'totalDurationMinutes': number;
    'segments': Array<MulticitySegment>;
    'departure': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof MulticitySlice
     */
    'destination': string;
    'arrival': string;
    'stops': number;
}
export interface MulticityTags {
    'isBest': boolean;
    'isCheapest': boolean;
    'isBestQuality': boolean;
    'isFastest': boolean;
}
export interface MulticityTrip {
    'id': string;
    'slices': Array<string>;
    'fares': Array<string>;
}
export interface NavitaireNdcBrand {
    'brandId'?: string;
    'brandName': string;
}
export interface NoFilter {
    'TripFilter': TripFilterEnum;
}


export interface NoLowCostCarrierFilter {
    'TripFilter': TripFilterEnum;
}


export interface NonStopFilter {
    'TripFilter': TripFilterEnum;
}


export interface NotEligible {
    'reason'?: string;
    'PriceDropProtection': PriceDropProtectionEnum;
}


export interface OfferWithSuggested {
    'offer': PriceFreezeOffer;
    'cheapestTrip': PriceFreezeCheapestTrip;
}
export interface OffersResponse {
    'bestOfferOverall'?: TravelWalletOffer;
    'offersByTripId': { [key: string]: TravelWalletOffer; };
}
export interface PassengerPricing {
    'paxType': string;
    'pricing': FarePricing;
    'quantity': number;
}
export interface Passengers {
    'adultCount': number;
    'childrenCount': number;
    'seatedInfantCount': number;
    'lapInfantCount': number;
}
/**
 * @type PenaltiesInfo
 * @export
 */
export type PenaltiesInfo = { PenaltiesInfo: 'ExternallyManaged' } & PenaltiesInfoExternallyManaged | { PenaltiesInfo: 'Known' } & PenaltiesInfoKnown | { PenaltiesInfo: 'Unknown' } & PenaltiesInfoUnknown;

export const PenaltiesInfoEnum = {
    ExternallyManaged: 'ExternallyManaged',
    Known: 'Known',
    Unknown: 'Unknown'
} as const;

export type PenaltiesInfoEnum = typeof PenaltiesInfoEnum[keyof typeof PenaltiesInfoEnum];


export interface PenaltiesInfoExternallyManaged {
    'code': string;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoKnown {
    'changePenalty': Penalty;
    'cancelPenalty': Penalty;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoUnknown {
    'PenaltiesInfo': PenaltiesInfoEnum;
}


/**
 * @type Penalty
 * @export
 */
export type Penalty = { Penalty: 'NoPenalty' } & PenaltyNoPenalty | { Penalty: 'NotPossible' } & PenaltyNotPossible | { Penalty: 'Unknown' } & PenaltyUnknown | { Penalty: 'WithFee' } & PenaltyWithFee;

export const PenaltyEnum = {
    NoPenalty: 'NoPenalty',
    NotPossible: 'NotPossible',
    Unknown: 'Unknown',
    WithFee: 'WithFee'
} as const;

export type PenaltyEnum = typeof PenaltyEnum[keyof typeof PenaltyEnum];


export interface PenaltyNoPenalty {
    'Penalty': PenaltyEnum;
}


export interface PenaltyNotPossible {
    'Penalty': PenaltyEnum;
}


export interface PenaltyUnknown {
    'Penalty': PenaltyEnum;
}


export interface PenaltyWithFee {
    'amount': number;
    'currency': string;
    'Penalty': PenaltyEnum;
}


export const Platform = {
    Desktop: 'Desktop',
    Mobile: 'Mobile'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];


export interface PolicyCompliance {
    'isInPolicy': boolean;
    'reasons': Array<string>;
}
export interface PolicyV2 {
    'headline': string;
    'description'?: string;
    'assessment': AssessmentV2;
    'fee'?: Fee;
}


export interface Power {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


/**
 * `recommendation` - Deprecated. Use `recommendationV2`
 * @export
 * @interface Prediction
 */
export interface Prediction {
    'predictionCopy'?: PredictionCopy;
    'recommendation'?: Recommendation;
    'lowestPrice': Prices;
    'recommendationV2': RecommendationV2;
    'PredictionResult': PredictionResultEnum;
    'priceDropProtection': PriceDropProtection;
    'pricePrediction': PricePrediction;
    'dealness': Dealness;
}


export interface PredictionCopy {
    'recommendationBodyWatching': Array<string>;
    'carrier': string;
    'recommendationTitleWatching': Array<string>;
    'intervals': Intervals;
    'recommendationBody': Array<string>;
    'lowestPriceLabel': string;
    'recommendationTitleJustWatched': Array<string>;
    'lowestPrice': string;
    'recommendationBodyJustWatched': Array<string>;
    'travelDates': string;
    'origin': string;
    'recommendationTitle': Array<string>;
    'dealness': string;
    'destination': string;
}
/**
 * @type PredictionResult
 * @export
 */
export type PredictionResult = { PredictionResult: 'Prediction' } & Prediction | { PredictionResult: 'UnavailablePrediction' } & UnavailablePrediction;

export const PredictionResultEnum = {
    Prediction: 'Prediction',
    UnavailablePrediction: 'UnavailablePrediction'
} as const;

export type PredictionResultEnum = typeof PredictionResultEnum[keyof typeof PredictionResultEnum];


export interface PriceDropMaximumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMinimumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMonitoringDuration {
    'inSeconds': number;
}
/**
 * @type PriceDropProtection
 * @export
 */
export type PriceDropProtection = { PriceDropProtection: 'IsEligible' } & IsEligible | { PriceDropProtection: 'NotEligible' } & NotEligible;

export const PriceDropProtectionEnum = {
    IsEligible: 'IsEligible',
    NotEligible: 'NotEligible'
} as const;

export type PriceDropProtectionEnum = typeof PriceDropProtectionEnum[keyof typeof PriceDropProtectionEnum];


export interface PriceFreezeAvailable {
    'offer': OfferWithSuggested;
    'PriceFreezeResult': PriceFreezeResultEnum;
}


/**
 * `isCheapest` - Is the offer related to the cheapest trip
 * @export
 * @interface PriceFreezeCheapestTrip
 */
export interface PriceFreezeCheapestTrip {
    'tripId': string;
    'fareId': string;
    /**
     * Is the offer related to the cheapest trip
     * @type {boolean}
     * @memberof PriceFreezeCheapestTrip
     */
    'isCheapest': boolean;
}
export interface PriceFreezeOffer {
    'seatedPassengers': { [key: string]: number; };
    'voidWindowAvailabilityEnd': VoidWindowAvailabilityEnd;
    'passengers': { [key: string]: number; };
    'totalAmount': Prices;
    'id': string;
    'timeToLive': PriceFreezeOfferTimeToLive;
    'perPaxAmount': Prices;
    'cap': PriceFreezeOfferCap;
}
export interface PriceFreezeOfferCap {
    'value': Amount;
}
export interface PriceFreezeOfferTimeToLive {
    'inSeconds': number;
    'inHours'?: number;
    'inDays'?: number;
}
/**
 * @type PriceFreezeResult
 * @export
 */
export type PriceFreezeResult = { PriceFreezeResult: 'PriceFreezeAvailable' } & PriceFreezeAvailable | { PriceFreezeResult: 'PriceFreezeUnavailable' } & PriceFreezeUnavailable;

export const PriceFreezeResultEnum = {
    PriceFreezeAvailable: 'PriceFreezeAvailable',
    PriceFreezeUnavailable: 'PriceFreezeUnavailable'
} as const;

export type PriceFreezeResultEnum = typeof PriceFreezeResultEnum[keyof typeof PriceFreezeResultEnum];


export const PriceFreezeUnavailabilityReason = {
    FlightIneligible: 'FlightIneligible',
    InternalError: 'InternalError',
    NoFlights: 'NoFlights',
    Unknown: 'Unknown'
} as const;

export type PriceFreezeUnavailabilityReason = typeof PriceFreezeUnavailabilityReason[keyof typeof PriceFreezeUnavailabilityReason];


export interface PriceFreezeUnavailable {
    'reason': PriceFreezeUnavailabilityReason;
    'PriceFreezeResult': PriceFreezeResultEnum;
}


export interface PricePrediction {
    'minPrice'?: DisplayAmount;
    'maxPrice'?: DisplayAmount;
}
/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
/**
 * Deprecated. Use `recommendationV2`
 * @export
 * @enum {string}
 */

export const Recommendation = {
    Buy: 'Buy',
    Wait: 'Wait'
} as const;

export type Recommendation = typeof Recommendation[keyof typeof Recommendation];


export const RecommendationV2 = {
    Buy: 'Buy',
    BuyNeutral: 'BuyNeutral',
    Wait: 'Wait',
    WaitNeutral: 'WaitNeutral'
} as const;

export type RecommendationV2 = typeof RecommendationV2[keyof typeof RecommendationV2];


export const RegionType = {
    airport: 'airport',
    city: 'city'
} as const;

export type RegionType = typeof RegionType[keyof typeof RegionType];


export const ResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type ResponseEnum = typeof ResponseEnum[keyof typeof ResponseEnum];


/**
 * A description of a route's origin and destination
 * @export
 * @interface Route
 */
export interface Route {
    'origin': AirportRegion;
    'destination': AirportRegion;
}
export interface SabreBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * Additional context for autocomplete search.
    The active control property is the input field that the user is currently interacting with.
    The optional origin and destination properties are the current values of the origin and destination input fields if they've been provided.
    Other search parameters such as departure and return date could be added in the future to further refine results.
 * @export
 * @interface SearchParameters
 */
export interface SearchParameters {
    'activeControl': Control;
    'destination'?: string;
    'origin'?: string;
}


export interface Seat {
    'flatness': SeatFlatness;
    'info': AmenityInfo;
    'pitch': string;
    'legroom': SeatLegroom;
    'width': SeatWidth;
}


export const SeatFlatness = {
    angle_flat: 'angle_flat',
    full_flat: 'full_flat',
    na: 'na',
    not_flat: 'not_flat'
} as const;

export type SeatFlatness = typeof SeatFlatness[keyof typeof SeatFlatness];


export const SeatLegroom = {
    less: 'less',
    more: 'more',
    na: 'na',
    standard: 'standard'
} as const;

export type SeatLegroom = typeof SeatLegroom[keyof typeof SeatLegroom];


export const SeatWidth = {
    na: 'na',
    standard: 'standard',
    wider: 'wider'
} as const;

export type SeatWidth = typeof SeatWidth[keyof typeof SeatWidth];


export interface Segment {
    'plusDays': number;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Segment
     */
    'marketingAirline': string;
    'stopoverDurationMinutes'?: number;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Segment
     */
    'origin': string;
    'departure': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Segment
     */
    'operatingAirline': string;
    'flightNumber': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Segment
     */
    'destination': string;
    'arrival': string;
}
export interface SegmentShelf {
    'rating': number;
    'brandName': string;
    'shortBrandName': string;
    'opaqueMapperStep'?: string;
}
export const ShopFilter = {
    NoFilter: 'NoFilter',
    NoLCC: 'NoLCC',
    NonStop: 'NonStop',
    NonStopNoLCC: 'NonStopNoLCC',
    ShortLayover: 'ShortLayover',
    ShortLayoverNoLCC: 'ShortLayoverNoLCC'
} as const;

export type ShopFilter = typeof ShopFilter[keyof typeof ShopFilter];


export interface ShopId {
    'value': string;
}
/**
 * @type ShopMulticitySummaryErrors
 * @export
 */
export type ShopMulticitySummaryErrors = { ShopMulticitySummaryErrors: 'InvalidSearchLocation' } & InvalidSearchLocation;

export const ShopMulticitySummaryErrorsEnum = {
    InvalidSearchLocation: 'InvalidSearchLocation'
} as const;

export type ShopMulticitySummaryErrorsEnum = typeof ShopMulticitySummaryErrorsEnum[keyof typeof ShopMulticitySummaryErrorsEnum];


export interface ShopMulticitySummaryErrorsErr {
    'err': ShopMulticitySummaryErrors;
    'Result': ShopMulticitySummarySuccessResultEnum;
}


export interface ShopMulticitySummaryRequest {
    'routes': Array<MulticityRoute>;
    'tripFilter': ShopFilter;
    'passengers': { [key: string]: number; };
    'platform': Platform;
}


export interface ShopMulticitySummaryResponse {
    'result': ShopMulticitySummarySuccessResult;
}
export interface ShopMulticitySummarySuccess {
    'flights': MulticityFlights;
}
export interface ShopMulticitySummarySuccessOk {
    'value': ShopMulticitySummarySuccess;
    'Result': ShopMulticitySummarySuccessResultEnum;
}


/**
 * @type ShopMulticitySummarySuccessResult
 * @export
 */
export type ShopMulticitySummarySuccessResult = { Result: 'Err' } & ShopMulticitySummaryErrorsErr | { Result: 'Ok' } & ShopMulticitySummarySuccessOk;

export const ShopMulticitySummarySuccessResultEnum = {
    Err: 'Err',
    Ok: 'Ok'
} as const;

export type ShopMulticitySummarySuccessResultEnum = typeof ShopMulticitySummarySuccessResultEnum[keyof typeof ShopMulticitySummarySuccessResultEnum];


export interface ShopSummaryAirline {
    'code': string;
    'name': string;
}
export interface ShopSummaryRequest {
    'originLocationLabel'?: string;
    'passengers': { [key: string]: number; };
    'destinationLocationLabel'?: string;
    'fareClass'?: Array<string>;
    'returnDate'?: string;
    'route': Route;
    'tripFilter': ShopFilter;
    'platform': Platform;
    'departureDate': string;
}


export interface ShopSummaryResponse {
    'tripSummaries': Array<TripSummary>;
    'prediction'?: PredictionResult;
    'priceFreezeOffer'?: OfferWithSuggested;
}
export interface ShopSummaryResponseV2 {
    'flights': Flights;
    'prediction'?: PredictionResult;
    'priceFreezeOffer'?: OfferWithSuggested;
    'offers'?: OffersResponse;
}
/**
 * @type ShopSummaryResponseV2Response
 * @export
 */
export type ShopSummaryResponseV2Response = { Response: 'Failure' } & Failure | { Response: 'Success' } & ShopSummaryResponseV2Success;

export interface ShopSummaryResponseV2Success {
    'value': ShopSummaryResponseV2;
    'Response': ResponseEnum;
}


export interface ShopSummaryResponseV4 {
    'priceFreezeOffer'?: PriceFreezeResult;
    'trackingProperties': TrackingProperties;
    'prediction'?: PredictionResult;
    'flights': Flights;
    'offers'?: OffersResponse;
}
/**
 * @type ShopSummaryResponseV4Response
 * @export
 */
export type ShopSummaryResponseV4Response = { Response: 'Failure' } & Failure | { Response: 'Success' } & ShopSummaryResponseV4Success;

export interface ShopSummaryResponseV4Success {
    'value': ShopSummaryResponseV4;
    'Response': ResponseEnum;
}


export interface ShopTripDetailsFareSegment {
    'penaltiesInfo': PenaltiesInfo;
    'ticketIndex'?: number;
    'outgoing': boolean;
    'brand'?: FareBrand;
    'carrierCabinClass'?: string;
    'code'?: string;
    'codes': { [key: string]: string; };
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof ShopTripDetailsFareSegment
     */
    'validatingCarrierCode'?: string;
    'sliceIndex': number;
    'bookingCode'?: string;
    'privateFare'?: boolean;
    'connection'?: boolean;
    'isSelfTransferLayover': boolean;
    'availableSeats': number;
    'baggageInfo': TripDetailsBaggageInfo;
    'cabinClassName'?: string;
}
export interface ShopTripDetailsFareSlice {
    'segments': Array<ShopTripDetailsFareSegment>;
}
export interface ShortLayoverFilter {
    'TripFilter': TripFilterEnum;
}


/**
 * `hasSelfTransferLayover` - if true, the user must transfer between airlines/gates/airports in order to reach their next flight on the following segment
 * `highestScore` - deprecate. this is not actually accurate since the same `return` slice on multiple slices can have different `FareScore` depending on the `outbound` slice selected.
 * @export
 * @interface Slice
 */
export interface Slice {
    'domestic': boolean;
    /**
     * if true, the user must transfer between airlines/gates/airports in order to reach their next flight on the following segment
     * @type {boolean}
     * @memberof Slice
     */
    'hasSelfTransferLayover': boolean;
    'highestScore': FlightsFareScore;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Slice
     */
    'marketingAirline': string;
    'lowestPrice'?: number;
    'id': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Slice
     */
    'origin': string;
    'totalDurationMinutes': number;
    'segments': Array<Segment>;
    'departure': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Slice
     */
    'destination': string;
    'arrival': string;
    'stops': number;
}
export interface SliceDeparture {
    'slice': string;
    'fares': Array<FareSliceDeparture>;
    'highestScore': MulticityFlightsFareScore;
    'lowestPrice'?: number;
}
/**
 * `highestScore` - The highest possible `FareScore` associated with a flight with this outbound `FareSlice`
 * @export
 * @interface SliceOutbound
 */
export interface SliceOutbound {
    'latestReturnArrival'?: string;
    'earliestReturnArrival'?: string;
    'highestScore': FlightsFareScore;
    'slice': string;
    'fares': Array<FareSliceOutbound>;
    'latestReturnDeparture'?: string;
    'earliestReturnDeparture'?: string;
}
export interface Suggestion {
    'subLabel'?: string;
    'label': string;
    'thumbnail'?: string;
    'id': Id;
    'trackingPropertiesV2': TrackingProperties;
}
export interface Tags {
    'isBest': boolean;
    'isCheapest': boolean;
    'isBestQuality': boolean;
    'isFastest': boolean;
}
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface TravelFusionBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * `percentage` - Percentage discount amount for percentage offer
 * `amount` - Discount amount in USD
 * `imageId` - Image name that's set in the offer config
 * `maxDiscountAmount` - Max discount amount in USD for percentage offer
 * @export
 * @interface TravelWalletOffer
 */
export interface TravelWalletOffer {
    /**
     * Percentage discount amount for percentage offer
     * @type {number}
     * @memberof TravelWalletOffer
     */
    'percentage'?: number;
    'shopPageBanner'?: string;
    'funnels': Array<Funnel>;
    'amount': Amount;
    'expiresOn': string;
    'availabilityPageBanner'?: string;
    'id': string;
    /**
     * Image name that's set in the offer config
     * @type {string}
     * @memberof TravelWalletOffer
     */
    'imageId'?: string;
    'trackingPropertiesV2': TrackingProperties;
    'termsAndConditions'?: string;
    'title': string;
    'landingPageBanner'?: string;
    'maxDiscountAmount'?: Amount;
    'descriptions': Array<string>;
}
export interface TravelportBrand {
    'brandId': string;
    'brandName'?: string;
    'brandTier'?: number;
}
export interface Trip {
    'id': string;
    'outbound': string;
    'return'?: string;
    'fares': Array<string>;
}
export interface TripContext {
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
}
export interface TripDetailsBaggageAllowance {
    'pieces': number;
    'descriptions': Array<string>;
    'maximumMass'?: Mass;
}
/**
 * @type TripDetailsBaggageInfo
 * @export
 */
export type TripDetailsBaggageInfo = { BaggageInfo: 'Allowed' } & TripDetailsBaggageInfoAllowed | { BaggageInfo: 'NotAllowed' } & TripDetailsBaggageInfoNotAllowed | { BaggageInfo: 'Unknown' } & TripDetailsBaggageInfoUnknown;

export interface TripDetailsBaggageInfoAllowed {
    'allowance': TripDetailsBaggageAllowance;
    'charges': Array<BaggageCharge>;
    'BaggageInfo': TripDetailsBaggageInfoEnum;
}


export const TripDetailsBaggageInfoEnum = {
    Allowed: 'Allowed',
    NotAllowed: 'NotAllowed',
    Unknown: 'Unknown'
} as const;

export type TripDetailsBaggageInfoEnum = typeof TripDetailsBaggageInfoEnum[keyof typeof TripDetailsBaggageInfoEnum];


export interface TripDetailsBaggageInfoNotAllowed {
    'BaggageInfo': TripDetailsBaggageInfoEnum;
}


export interface TripDetailsBaggageInfoUnknown {
    'BaggageInfo': TripDetailsBaggageInfoEnum;
}


/**
 * `airports` - Airports for each destination and origin in each SegmentDetails of the TripSlices
 * @export
 * @interface TripDetailsV2
 */
export interface TripDetailsV2 {
    /**
     * Airports for each destination and origin in each SegmentDetails of the TripSlices
     * @type {Array<Airport>}
     * @memberof TripDetailsV2
     */
    'airports': Array<Airport>;
    'pointOfSaleCountryCode': string;
    'fareDetails': Array<FareDetailsV2>;
    'id': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof TripDetailsV2
     */
    'validatingCarrierCode'?: string;
    'tripDescription': string;
    'slices': Array<TripSlice>;
}
export interface TripFare {
    'fareShelf'?: FareShelf;
    'isMultiTicket': boolean;
    'brandType': BrandType;
    'lastTicketDate'?: string;
    'fareId': string;
    'amount': Prices;
    'slices': Array<TripFareFareSlice>;
    'fareScore': FareScore;
}


export interface TripFareFareSegment {
    'availableSeats': number;
}
export interface TripFareFareSlice {
    'segments': Array<TripFareFareSegment>;
    'brandType': BrandType;
}


/**
 * @type TripFilter
 * @export
 */
export type TripFilter = { TripFilter: 'AndFilter' } & AndFilter | { TripFilter: 'NoFilter' } & NoFilter | { TripFilter: 'NoLowCostCarrierFilter' } & NoLowCostCarrierFilter | { TripFilter: 'NonStopFilter' } & NonStopFilter | { TripFilter: 'ShortLayoverFilter' } & ShortLayoverFilter;

export const TripFilterEnum = {
    AndFilter: 'AndFilter',
    NoFilter: 'NoFilter',
    NoLowCostCarrierFilter: 'NoLowCostCarrierFilter',
    NonStopFilter: 'NonStopFilter',
    ShortLayoverFilter: 'ShortLayoverFilter'
} as const;

export type TripFilterEnum = typeof TripFilterEnum[keyof typeof TripFilterEnum];


export interface TripId {
    'value': string;
}
export interface TripProperties {
    'route': Route;
    'departureDate': string;
    'returnDate'?: string;
}
/**
 * `stops` - These are refueling stops. It's not indicative of layovers
 * @export
 * @interface TripSegment
 */
export interface TripSegment {
    'departureTime': string;
    'airlineName': string;
    'airlineCode': string;
    'zonedDepartureTime': string;
    'zonedArrivalTime': string;
    'plusDays': number;
    'marketingAirline': ShopSummaryAirline;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'originName': string;
    'stopoverDurationMinutes'?: number;
    'operatingAirline': ShopSummaryAirline;
    'flightNumber': string;
    'destinationCode': string;
    /**
     * These are refueling stops. It's not indicative of layovers
     * @type {number}
     * @memberof TripSegment
     */
    'stops': number;
}
export interface TripSlice {
    'departureTime': string;
    'zonedDepartureTime': string;
    'outgoing': boolean;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'id': string;
    'segmentDetails': Array<TripSegment>;
    'originName': string;
    'totalDurationMinutes': number;
    'destinationCode': string;
    'stops': number;
}
export interface TripSummary {
    /**
     * 2 character country code
     * @type {string}
     * @memberof TripSummary
     */
    'domestic'?: string;
    'tripFares': Array<TripFare>;
    'context': TripContext;
    'tripId': string;
    'outgoingSlice': TripSlice;
    'returningSlice'?: TripSlice;
}
export const TripType = {
    one_way: 'one_way',
    open_jaw: 'open_jaw',
    round_trip: 'round_trip'
} as const;

export type TripType = typeof TripType[keyof typeof TripType];


/**
 * When a flight cannot be currently voided
 * @export
 * @interface Unavailable
 */
export interface Unavailable {
    'VoidWindowAvailabilityEnd': VoidWindowAvailabilityEndEnum;
}


export interface UnavailablePrediction {
    'reason': string;
    'PredictionResult': PredictionResultEnum;
}


/**
 * When a flight currently has a void window, with information about when it ends
 * @export
 * @interface Until
 */
export interface Until {
    'time': string;
    'VoidWindowAvailabilityEnd': VoidWindowAvailabilityEndEnum;
}


export interface Upa {
    'headline': string;
    'description': string;
    'icon'?: Icon;
    'cta'?: Cta;
    'category': UpaCategory;
}


export const UpaCategory = {
    brand: 'brand',
    promotion: 'promotion',
    promotion_position1: 'promotion-position1',
    unrecognized: 'unrecognized'
} as const;

export type UpaCategory = typeof UpaCategory[keyof typeof UpaCategory];


export interface Uta {
    'headline': string;
    'description': string;
    'icon'?: Icon;
    'bagLimits': BagLimits;
    'cta'?: Cta;
    'category': UtaCategory;
    'assessment': UtaAssessment;
}


export const UtaAssessment = {
    benefit: 'benefit',
    fee: 'fee',
    neutral: 'neutral',
    restriction: 'restriction'
} as const;

export type UtaAssessment = typeof UtaAssessment[keyof typeof UtaAssessment];


export const UtaCategory = {
    advance_change: 'advance-change',
    boarding_priority: 'boarding-priority',
    cancellation: 'cancellation',
    carry_on_allowance: 'carry-on-allowance',
    check_in_priority: 'check-in-priority',
    checked_bag_allowance: 'checked-bag-allowance',
    lounge_access: 'lounge-access',
    personal_item: 'personal-item',
    refundable_fare: 'refundable-fare',
    same_day_change: 'same-day-change',
    seat_selection: 'seat-selection',
    upgrade_eligibility: 'upgrade-eligibility'
} as const;

export type UtaCategory = typeof UtaCategory[keyof typeof UtaCategory];


export interface UtasV2 {
    'fare'?: AmenitiesFare;
    'utas': Array<Uta>;
    'changePolicy'?: MultiPolicyV2;
    'cancellationPolicy'?: MultiPolicyV2;
}
/**
 * @type VoidWindowAvailabilityEnd
 * Information about availability of a void window for a flight (=cancellable)
 * @export
 */
export type VoidWindowAvailabilityEnd = { VoidWindowAvailabilityEnd: 'Unavailable' } & Unavailable | { VoidWindowAvailabilityEnd: 'Until' } & Until;

export const VoidWindowAvailabilityEndEnum = {
    Unavailable: 'Unavailable',
    Until: 'Until'
} as const;

export type VoidWindowAvailabilityEndEnum = typeof VoidWindowAvailabilityEndEnum[keyof typeof VoidWindowAvailabilityEndEnum];


export interface WebLinks {
    'changeCancelPolicy'?: string;
    'otherFee'?: string;
    'checkInPolicy'?: string;
    'wifiFee'?: string;
    'homePage'?: string;
    'baggageFees'?: string;
    'seatUpgrade'?: string;
    'manageBooking'?: string;
    'seatSelection'?: string;
}
export interface Wifi {
    'info': AmenityInfo;
    'exists': AmenityExists;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get autocomplete responses based on location
         * @param {LocationQuery} locationQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AutocompleteLocationPost: async (locationQuery: LocationQuery, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationQuery' is not null or undefined
            assertParamExists('apiV0AutocompleteLocationPost', 'locationQuery', locationQuery)
            const localVarPath = `/api/v0/autocomplete/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get calendar buckets
         * @param {CalendarBuckets} calendarBuckets 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CalendarPost: async (calendarBuckets: CalendarBuckets, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarBuckets' is not null or undefined
            assertParamExists('apiV0CalendarPost', 'calendarBuckets', calendarBuckets)
            const localVarPath = `/api/v0/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarBuckets, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch shopSummaryV3
         * @param {ShopMulticitySummaryRequest} shopMulticitySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ShopMulticitySummaryPost: async (shopMulticitySummaryRequest: ShopMulticitySummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopMulticitySummaryRequest' is not null or undefined
            assertParamExists('apiV0ShopMulticitySummaryPost', 'shopMulticitySummaryRequest', shopMulticitySummaryRequest)
            const localVarPath = `/api/v0/shopMulticitySummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopMulticitySummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch shopSummaryV0
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ShopSummaryPost: async (shopSummaryRequest: ShopSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopSummaryRequest' is not null or undefined
            assertParamExists('apiV0ShopSummaryPost', 'shopSummaryRequest', shopSummaryRequest)
            const localVarPath = `/api/v0/shopSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a trip detail
         * @param {TripId} tripId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripDetailPost: async (tripId: TripId, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tripId' is not null or undefined
            assertParamExists('apiV0TripDetailPost', 'tripId', tripId)
            const localVarPath = `/api/v0/tripDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tripId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch shopSummaryV2
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ShopSummaryPost: async (shopSummaryRequest: ShopSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopSummaryRequest' is not null or undefined
            assertParamExists('apiV2ShopSummaryPost', 'shopSummaryRequest', shopSummaryRequest)
            const localVarPath = `/api/v2/shopSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch shopSummaryV3
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3ShopSummaryPost: async (shopSummaryRequest: ShopSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopSummaryRequest' is not null or undefined
            assertParamExists('apiV3ShopSummaryPost', 'shopSummaryRequest', shopSummaryRequest)
            const localVarPath = `/api/v3/shopSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch shopSummaryV4
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV4ShopSummaryPost: async (shopSummaryRequest: ShopSummaryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopSummaryRequest' is not null or undefined
            assertParamExists('apiV4ShopSummaryPost', 'shopSummaryRequest', shopSummaryRequest)
            const localVarPath = `/api/v4/shopSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shopSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get autocomplete responses based on location
         * @param {LocationQuery} locationQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AutocompleteLocationPost(locationQuery: LocationQuery, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AutocompleteLocationPost(locationQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get calendar buckets
         * @param {CalendarBuckets} calendarBuckets 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CalendarPost(calendarBuckets: CalendarBuckets, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarBucketsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CalendarPost(calendarBuckets, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch shopSummaryV3
         * @param {ShopMulticitySummaryRequest} shopMulticitySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ShopMulticitySummaryPost(shopMulticitySummaryRequest: ShopMulticitySummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopMulticitySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ShopMulticitySummaryPost(shopMulticitySummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch shopSummaryV0
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ShopSummaryPost(shopSummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch a trip detail
         * @param {TripId} tripId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TripDetailPost(tripId: TripId, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripDetailsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TripDetailPost(tripId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch shopSummaryV2
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopSummaryResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2ShopSummaryPost(shopSummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch shopSummaryV3
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV3ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopSummaryResponseV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV3ShopSummaryPost(shopSummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch shopSummaryV4
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV4ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShopSummaryResponseV4Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV4ShopSummaryPost(shopSummaryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get autocomplete responses based on location
         * @param {LocationQuery} locationQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AutocompleteLocationPost(locationQuery: LocationQuery, options?: any): AxiosPromise<LocationResponse> {
            return localVarFp.apiV0AutocompleteLocationPost(locationQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * Get calendar buckets
         * @param {CalendarBuckets} calendarBuckets 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CalendarPost(calendarBuckets: CalendarBuckets, options?: any): AxiosPromise<CalendarBucketsResponse> {
            return localVarFp.apiV0CalendarPost(calendarBuckets, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch shopSummaryV3
         * @param {ShopMulticitySummaryRequest} shopMulticitySummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ShopMulticitySummaryPost(shopMulticitySummaryRequest: ShopMulticitySummaryRequest, options?: any): AxiosPromise<ShopMulticitySummaryResponse> {
            return localVarFp.apiV0ShopMulticitySummaryPost(shopMulticitySummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch shopSummaryV0
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: any): AxiosPromise<ShopSummaryResponse> {
            return localVarFp.apiV0ShopSummaryPost(shopSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a trip detail
         * @param {TripId} tripId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TripDetailPost(tripId: TripId, options?: any): AxiosPromise<TripDetailsV2> {
            return localVarFp.apiV0TripDetailPost(tripId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch shopSummaryV2
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: any): AxiosPromise<ShopSummaryResponseV2> {
            return localVarFp.apiV2ShopSummaryPost(shopSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch shopSummaryV3
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: any): AxiosPromise<ShopSummaryResponseV2Response> {
            return localVarFp.apiV3ShopSummaryPost(shopSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch shopSummaryV4
         * @param {ShopSummaryRequest} shopSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV4ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: any): AxiosPromise<ShopSummaryResponseV4Response> {
            return localVarFp.apiV4ShopSummaryPost(shopSummaryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get autocomplete responses based on location
     * @param {LocationQuery} locationQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0AutocompleteLocationPost(locationQuery: LocationQuery, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0AutocompleteLocationPost(locationQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get calendar buckets
     * @param {CalendarBuckets} calendarBuckets 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0CalendarPost(calendarBuckets: CalendarBuckets, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0CalendarPost(calendarBuckets, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch shopSummaryV3
     * @param {ShopMulticitySummaryRequest} shopMulticitySummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ShopMulticitySummaryPost(shopMulticitySummaryRequest: ShopMulticitySummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ShopMulticitySummaryPost(shopMulticitySummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch shopSummaryV0
     * @param {ShopSummaryRequest} shopSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ShopSummaryPost(shopSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a trip detail
     * @param {TripId} tripId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0TripDetailPost(tripId: TripId, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0TripDetailPost(tripId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch shopSummaryV2
     * @param {ShopSummaryRequest} shopSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV2ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV2ShopSummaryPost(shopSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch shopSummaryV3
     * @param {ShopSummaryRequest} shopSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV3ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV3ShopSummaryPost(shopSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch shopSummaryV4
     * @param {ShopSummaryRequest} shopSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV4ShopSummaryPost(shopSummaryRequest: ShopSummaryRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV4ShopSummaryPost(shopSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



